'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNav } from './context.js';
import { NavIcon, WaffleIcon } from './icons.js';
/**
 * The waffle plus active-app chip a host places by hand in its own header, beside
 * its logo. This is the RESTORE control: while the bar is collapsed it is the only
 * way back, so it is visibly interactive and always carries the restore label.
 *
 * It is display:none while the bar is expanded (and therefore out of the
 * accessibility tree), which is why the label and aria-expanded are fixed rather
 * than swapped — the bar's own waffle is the hide control.
 */
function NavTrigger({ className }) {
    const { activeApp, collapsed, toggle } = useNav();
    const classes = ['ahsuite-docked', className ?? ''].filter(Boolean).join(' ');
    return (_jsxs("button", { "aria-expanded": false, "aria-label": "Show the suite bar", className: classes, "data-collapsed": collapsed ? 'true' : 'false', onClick: toggle, title: "Show the suite bar", type: "button", children: [_jsx("span", { className: "ahsuite-chip ahsuite-chip--active", children: _jsx(NavIcon, { name: activeApp?.app.icon ?? '' }) }), _jsx(WaffleIcon, { className: "ahsuite-waffle-mini" })] }));
}
export { NavTrigger };
//# sourceMappingURL=nav-trigger.js.map